class $073b825f3e9d2cd3$var$Task {
    constructor(title, description){
        this.title = title;
        this.description = description;
        this.completed = false;
        this.createdDate = new Date();
    }
    complete() {
        this.completed = true;
    }
    edit(newTaskObject) {
        const { newTitle: newTitle, newDescription: newDescription = this.description } = newTaskObject;
        this.title = newTitle;
        this.description = newDescription;
    }
}
var $073b825f3e9d2cd3$export$2e2bcd8739ae039 = $073b825f3e9d2cd3$var$Task;


const $391e6c202be82ed3$var$allUsers = {
    users: []
};
var $391e6c202be82ed3$export$2e2bcd8739ae039 = $391e6c202be82ed3$var$allUsers;


class $7d217b81ff1d49ef$var$User {
    constructor(name, username, password){
        this.name = name;
        this.username = username;
        this.password = password;
        this.tasks = [];
    }
    addTask(taskObject) {
        const { title: title, description: description } = taskObject;
        if (title && description) {
            const task = new (0, $073b825f3e9d2cd3$export$2e2bcd8739ae039)(title, description);
            this.tasks.push(task);
        } else console.error("Invalid task data.");
    }
    completeTask(taskIndex) {
        if (taskIndex >= 0 && taskIndex < this.tasks.length) this.tasks[taskIndex].complete();
        else console.error("Invalid task index.");
    }
    deleteTask(taskIndex) {
        if (taskIndex >= 0 && taskIndex < this.tasks.length) this.tasks.splice(taskIndex, 1);
        else console.error("Invalid task index.");
    }
    editTask(taskIndex, newTaskObject) {
        if (taskIndex >= 0 && taskIndex < this.tasks.length) this.tasks[taskIndex].edit(newTaskObject);
        else console.error("Invalid task index.");
    }
    static validateUser(username, password) {
        console.log((0, $391e6c202be82ed3$export$2e2bcd8739ae039));
        return (0, $391e6c202be82ed3$export$2e2bcd8739ae039).users.find((user)=>user.username === username && user.password === password);
    }
    static createUser(name, username, password) {
        // Check if the username already exists
        const existingUser = (0, $391e6c202be82ed3$export$2e2bcd8739ae039).users.find((user)=>user.username === username);
        if (existingUser) {
            console.log("User with this username already exists.");
            return null; // Returning null to indicate that user creation failed
        }
        // If the username is unique, create the new user
        const user = new $7d217b81ff1d49ef$var$User(name, username, password);
        (0, $391e6c202be82ed3$export$2e2bcd8739ae039).users.push(user);
        console.log((0, $391e6c202be82ed3$export$2e2bcd8739ae039));
        return user;
    }
}
const $7d217b81ff1d49ef$var$object = [
    {
        "name": "John Doe",
        "username": "johndoe123",
        "password": "password123",
        "tasks": [
            {
                "title": "Task 1",
                "description": "Complete assignment"
            },
            {
                "title": "Task 2",
                "description": "Read a book"
            }
        ]
    },
    {
        "name": "Alice Johnson",
        "username": "alicej",
        "password": "securepwd",
        "tasks": [
            {
                "title": "Task 1",
                "description": "Attend meeting"
            },
            {
                "title": "Task 2",
                "description": "Prepare presentation"
            }
        ]
    },
    {
        "name": "Bob Smith",
        "username": "bobsmith",
        "password": "12345",
        "tasks": [
            {
                "title": "Task 1",
                "description": "Write report"
            }
        ]
    },
    {
        "name": "Eva Brown",
        "username": "evab",
        "password": "evapassword",
        "tasks": [
            {
                "title": "Task 1",
                "description": "Study for exam"
            },
            {
                "title": "Task 2",
                "description": "Complete homework"
            },
            {
                "title": "Make homework",
                "description": "If i get home, i will make some homework"
            }
        ]
    },
    {
        "name": "Michael White",
        "username": "michaelw",
        "password": "mypass123",
        "tasks": [
            {
                "title": "Task 1",
                "description": "Exercise"
            }
        ]
    }
];
$7d217b81ff1d49ef$var$object.forEach((obj)=>{
    const { name: name, username: username, password: password } = obj;
    const user = new $7d217b81ff1d49ef$var$User(name, username, password);
    if (obj.tasks) obj.tasks.forEach((task, index)=>{
        user.addTask(task);
        if (index === 1) user.completeTask(1);
    });
    (0, $391e6c202be82ed3$export$2e2bcd8739ae039).users.push(user);
});
var $7d217b81ff1d49ef$export$2e2bcd8739ae039 = $7d217b81ff1d49ef$var$User;


class $d0b2c38c793eadc2$var$LoginView {
    _parentEl = document.querySelector(".login-Signup-container");
    constructor(){
        this.addEventListener();
    }
    // Method to handle login button click
    addLoginHandler(callback) {
        this._parentEl.addEventListener("click", (event)=>{
            event.preventDefault();
            const loginButton = event.target.closest(".btn--to-log-in");
            if (loginButton) {
                const userData = {
                    username: this._parentEl.querySelector("#username").value,
                    password: this._parentEl.querySelector("#password").value
                };
                if (userData.username && userData.password) callback(userData); // Pass user data to the provided callback function
                else console.log("Login failed");
            }
        });
    }
    // Method to handle signup button click
    addSignupHandler(callback) {
        this._parentEl.addEventListener("click", (event)=>{
            event.preventDefault();
            const signupButton = event.target.closest(".btn--to-sign-up");
            if (signupButton) {
                const userData = {
                    name: this._parentEl.querySelector("#name").value,
                    username: this._parentEl.querySelector("#username").value,
                    password: this._parentEl.querySelector("#password").value
                };
                if (userData.name && userData.username && userData.password) callback(userData); // Pass user data to the provided callback function
                else console.log("Signup failed");
            }
        });
    }
    // Method to handle logout button click
    addLogoutHandler(callback) {
        this._parentEl.addEventListener("click", (event)=>{
            event.preventDefault();
            if (event.target.closest(".btn--log-out")) {
                callback();
                this._logout();
            }
        });
    }
    // Method to handle successful login
    loginSuccess() {
        this._clear();
        this._parentEl.insertAdjacentHTML("afterbegin", this._generateMarkup("loggedIn"));
    }
    // Method to handle logout
    _logout() {
        this._clear();
        this._parentEl.insertAdjacentHTML("afterbegin", this._generateMarkup("LoggedOut"));
    // Add your logout logic here
    }
    // Method to _clear the parent element content
    _clear() {
        this._parentEl.innerHTML = "";
    }
    // Method to generate markup based on the mode (login, signup, or logout)
    addEventListener() {
        this._parentEl.addEventListener("click", (event)=>{
            const loginBtn = event.target.closest(".btn--log-in");
            const signupBtn = event.target.closest(".btn--sign-up");
            if (loginBtn) {
                this._clear();
                this._parentEl.insertAdjacentHTML("afterbegin", this._generateMarkup("login"));
            } else if (signupBtn) {
                this._clear();
                this._parentEl.insertAdjacentHTML("afterbegin", this._generateMarkup("signup"));
            }
        });
    }
    // Method to generate markup based on the mode (login, signup, or logout)
    _generateMarkup(mode) {
        if (mode === "login") return `
	        <div class="login--container">
	            <div>
	                <input id="username" placeholder="username" value="johndoe123" type="text">
	            </div>
	            <div>
	                <input id="password" placeholder="********" value="password123" type="password">
	            </div>
	            <button type="submit" class="btn btn--to-log-in">Login</button>
	        </div>`;
        else if (mode === "signup") return `
	        <div class="register--container">
	            <div>
	                <input id="name" placeholder="name" type="text">
	            </div>
	            <div>
	                <input id="username" placeholder="username" type="text">
	            </div>
	            <div>
	                <input id="password" placeholder="********" type="password">
	            </div>
	            <button type="submit" class="btn btn--to-sign-up">Sign Up</button>
	        </div>`;
        else if (mode === "loggedIn") return `<span class="material-symbols-outlined btn--log-out">Logout</span>`;
        else if (mode === "LoggedOut") return `
			 <div class="login-Signup-container">
	            <div>
	                <button class="btn btn--sign-up">Sign up</button>
	                <button class="btn btn--log-in">Log in</button>
	            </div>
        	</div>
			`;
    }
}
var $d0b2c38c793eadc2$export$2e2bcd8739ae039 = new $d0b2c38c793eadc2$var$LoginView();


class $d3824bf2ef2465db$export$68962dbd27cd2e36 {
    constructor(date){
        this.date = date;
    }
    formattedDate;
    weekday;
    time;
    format() {
        return this.formattedDate = new Intl.DateTimeFormat(navigator.language, {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        }).format(this.date);
    }
}


class $5fe6c21f68d06263$var$TaskView {
    _parentEl = document.querySelector(".container");
    _overlay = this._parentEl.nextElementSibling;
    _taskFormContainer;
    _editTaskFormContainer;
    constructor(){
        this.addEventListener();
    }
    render(user) {
        this._clear();
        this._parentEl.innerHTML = this._generateMarkup(user);
    }
    addNewTaskHandler(callback) {
        this._parentEl.addEventListener("click", (event)=>{
            const addTaskBtn = event.target.closest(".add-task");
            if (!addTaskBtn) return;
            this._taskFormContainer = addTaskBtn.nextElementSibling;
            this._taskFormContainer.classList.toggle("hidden");
            this._overlay.classList.toggle("hidden");
            const form = this._taskFormContainer.querySelector(".task-form");
            if (form) form.addEventListener("submit", (event)=>{
                event.preventDefault();
                const taskObject = {
                    title: form.querySelector("#taskTitle").value,
                    description: form.querySelector("#taskDescription").value
                };
                if (taskObject.title) callback(taskObject);
                this._overlay.classList.toggle("hidden");
            });
        });
    }
    addEditTaskHandler(callback) {
        this._parentEl.addEventListener("click", (event)=>{
            const editTaskBtn = event.target.closest(".edit-task-btn");
            if (editTaskBtn) {
                const taskItem = editTaskBtn.closest(".task-item");
                if (taskItem) {
                    const taskIndex = taskItem.querySelector(".task-status").getAttribute("data-id");
                    const taskTitle = taskItem.querySelector(".task-title").textContent;
                    const taskDescription = taskItem.querySelector(".task-description").textContent;
                    // Create a form element with a placeholder of the task title and description
                    this._overlay.classList.toggle("hidden");
                    this._editTaskFormContainer = document.createElement("div");
                    this._editTaskFormContainer.classList.add("task-modal");
                    this._editTaskFormContainer.innerHTML = `
                    <form class="task-form">
                        <h2 class="task-form__title">Edit Task</h2>
                        <input type="text" id="taskTitle" value="${taskTitle}" class="task-form__title-input" required>
                        <input type="text" id="taskDescription" value="${taskDescription}" class="task-form__description-input">
                        <button type="submit" class="btn task-form__btn-submit">Edit Task</button>
                    </form>`;
                    this._parentEl.querySelector(".task-container").appendChild(this._editTaskFormContainer);
                    // Add event listener to the form
                    this._editTaskFormContainer.addEventListener("submit", (event)=>{
                        event.preventDefault();
                        const taskObject = {
                            newTitle: this._editTaskFormContainer.querySelector("#taskTitle").value,
                            newDescription: this._editTaskFormContainer.querySelector("#taskDescription").value
                        };
                        callback(taskIndex, taskObject);
                        this._overlay.classList.add("hidden");
                        this._editTaskFormContainer.remove();
                    });
                }
            }
        });
    }
    addCompleteHandler(callback) {
        this._parentEl.addEventListener("change", (event)=>{
            if (event.target.closest(".task-status")) {
                const taskIndex = event.target.closest(".task-status").getAttribute("data-id");
                callback(taskIndex);
            }
        });
    }
    addEventListener() {
        this._overlay.addEventListener("click", (event)=>{
            this._overlay.classList.add("hidden");
            if (this._taskFormContainer) this._taskFormContainer.classList.add("hidden");
            if (this._editTaskFormContainer) {
                console.log("I got here");
                this._editTaskFormContainer.remove(); // Remove the edit task form container
                this._editTaskFormContainer = null;
            }
        });
    }
    logout() {
        this._parentEl.innerHTML = "";
    }
    _clear() {
        this._parentEl.innerHTML = "";
    }
    _generateMarkup(User) {
        const formatDate = new (0, $d3824bf2ef2465db$export$68962dbd27cd2e36)();
        if (!User) return `
				<div class="head-container ">
			        <div class="head-text-container">
			            <h1 class="primary-heading">Stay Organized, <span>Stay Productive</span></h1>
			            <p className="hero-description">Taskly helps you manage your tasks efficiently, so you can focus on what
			                matters most. From personal to professional, conquer your to-do list with ease.</p>
			        </div>
	            </div>`;
        return `
		<div class="logon">
            <div class="message-container ">
                <h2 class="message">Good Morning, <span class="name">${User.name.split(" ")[0]}</span></h2>
            </div>

            <div class="task-container ">
			<button type="submit" class="add-task btn--to-add"><span class="material-symbols-outlined">add</span></button>
			<div class="task-modal hidden">
			  <form id="taskForm" class="task-form">
				<input type="text" id="taskTitle" placeholder="Task Title" class="task-form__title-input" required>
				<input type="text" id="taskDescription" placeholder="Task Description" class="task-form__description-input">
				<button type="submit" class="btn--submit task-form__btn-submit">Submit</button>
			  </form>
			</div>

                <ul class="task-list">
                   ${User.tasks.map((task, index)=>`<li class="task-item ${task.completed ? "task-item--done" : ""}">
                        <input type="checkbox" ${task.completed ? "checked" : ""} class="task-status" data-id="${index}">
                        <div class="task-content">
                            <h3 class="task-title">${task.title}</h3>
                            <p class="task-description">${task.description}</p>
                            <p class="task-due-date">${formatDate.format(task.createdDate)}</p>
                        </div>
                        <button class="btn edit-task-btn">Edit Task</button>
                    </li>`).join("")}
                </ul>
            </div>
        </div>`;
    }
}
var $5fe6c21f68d06263$export$2e2bcd8739ae039 = new $5fe6c21f68d06263$var$TaskView();


"use strict";
let $8f6a480bb40b134f$var$loginStatus;
let $8f6a480bb40b134f$var$activeUser;
function $8f6a480bb40b134f$var$controlLoginIn(user) {
    if (!user) return;
    $8f6a480bb40b134f$var$activeUser = (0, $7d217b81ff1d49ef$export$2e2bcd8739ae039).validateUser(user.username, user.password);
    if ($8f6a480bb40b134f$var$activeUser) $8f6a480bb40b134f$var$loginStatus = true;
    else {
        console.log("Login failed");
        $8f6a480bb40b134f$var$loginStatus = false;
    }
    if ($8f6a480bb40b134f$var$loginStatus) {
        (0, $d0b2c38c793eadc2$export$2e2bcd8739ae039).loginSuccess();
        (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
    }
}
function $8f6a480bb40b134f$var$controlSignUp(user) {
    if (!user) return;
    $8f6a480bb40b134f$var$activeUser = (0, $7d217b81ff1d49ef$export$2e2bcd8739ae039).createUser(user.name, user.username, user.password);
    if ($8f6a480bb40b134f$var$activeUser) {
        console.log("Signup successful");
        $8f6a480bb40b134f$var$loginStatus = true;
    } else {
        console.log("Signup failed");
        $8f6a480bb40b134f$var$loginStatus = false;
    }
    if ($8f6a480bb40b134f$var$loginStatus) {
        (0, $d0b2c38c793eadc2$export$2e2bcd8739ae039).loginSuccess();
        (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
    }
}
function $8f6a480bb40b134f$var$controlAddTask(taskObject) {
    if (!$8f6a480bb40b134f$var$loginStatus && !$8f6a480bb40b134f$var$activeUser) return;
    $8f6a480bb40b134f$var$activeUser.addTask(taskObject);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
}
function $8f6a480bb40b134f$var$controlEditTask(taskIndex, newTaskObject) {
    if (!$8f6a480bb40b134f$var$loginStatus && !$8f6a480bb40b134f$var$activeUser) return;
    if (!taskIndex) return;
    $8f6a480bb40b134f$var$activeUser.editTask(taskIndex, newTaskObject);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
}
function $8f6a480bb40b134f$var$controlDeleteTask(taskIndex) {
    if (!$8f6a480bb40b134f$var$loginStatus && !$8f6a480bb40b134f$var$activeUser) return;
    if (!taskIndex) return;
    $8f6a480bb40b134f$var$activeUser.deleteTask(taskIndex);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
}
function $8f6a480bb40b134f$var$controlCompleteTask(taskIndex) {
    if (!$8f6a480bb40b134f$var$loginStatus && !$8f6a480bb40b134f$var$activeUser) return;
    if (!taskIndex) return;
    $8f6a480bb40b134f$var$activeUser.completeTask(taskIndex);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
}
function $8f6a480bb40b134f$var$controlLogOut() {
    $8f6a480bb40b134f$var$loginStatus = false;
    $8f6a480bb40b134f$var$activeUser = null;
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).render($8f6a480bb40b134f$var$activeUser);
}
function $8f6a480bb40b134f$var$init() {
    (0, $d0b2c38c793eadc2$export$2e2bcd8739ae039).addLoginHandler($8f6a480bb40b134f$var$controlLoginIn);
    (0, $d0b2c38c793eadc2$export$2e2bcd8739ae039).addSignupHandler($8f6a480bb40b134f$var$controlSignUp);
    (0, $d0b2c38c793eadc2$export$2e2bcd8739ae039).addLogoutHandler($8f6a480bb40b134f$var$controlLogOut);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).addNewTaskHandler($8f6a480bb40b134f$var$controlAddTask);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).addEditTaskHandler($8f6a480bb40b134f$var$controlEditTask);
    (0, $5fe6c21f68d06263$export$2e2bcd8739ae039).addCompleteHandler($8f6a480bb40b134f$var$controlCompleteTask);
}
$8f6a480bb40b134f$var$init();


//# sourceMappingURL=index.584a8f7d.js.map
